import { useEffect, useCallback, Dispatch } from 'react';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import { History } from 'history';
import { connect, ConnectedProps, useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from '../store/config/types';
import { AppActions } from '../store/config/ActionTypes';
import * as actions from '../store/actions/auth.actions';
import indexRoutes from '../utils/routes';
import Layout from '../components/Layout/Layout';
import Spinner from '../components/Spinner/Spinner';
import Login from './Auth/Login';
import { hasPermission } from '../utils/permissions';

const mapStateToProps = (state: RootState) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, any, AppActions>) => ({
  logout: () => dispatch(actions.logout()),
  getAccount: (shipperUserId: number) => dispatch(actions.getAccount(shipperUserId)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

function Main({ auth, getAccount }: PropsFromRedux) {
  const dispatch: Dispatch<any> = useDispatch();
  const history: History = useHistory();

  useEffect(() => {
    const currentURL: string = window.location.href;
    if (!auth.loggedIn) {
      const token: string | null = localStorage.getItem('token');
      if (!token) {
        if (!currentURL.includes('login')) {
          const redirect = `${window.location.pathname}${window.location.search}`;
          history.push(`/login?redirect=${encodeURIComponent(redirect)}`);
          location.reload();
        }
      } else {
        const shipperUserId: string | null = localStorage.getItem('shipperUserId');
        getAccount(Number(shipperUserId));
      }
    } else if (currentURL.includes('login')) {
      history.push('/home');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, history, auth.loggedIn]);

  const handleOnLogout = useCallback(() => {
    history.push('/login');
    dispatch(actions.logout());
  }, [dispatch, history]);

  if (!auth.loggedIn && !window.location.href.includes('login')) {
    return (
      <div className="SpinnerContainer">
        <Spinner />
      </div>
    );
  }
  const user = auth.account;
  return (
    <>
      <Switch>
        <Route path="/login" component={Login} />
        <Layout onLogout={handleOnLogout}>
          {indexRoutes.map((route, key) => {
            if (user && hasPermission(user, route.permissions ?? [])) {
              route.hasPermission = true;
              return <Route exact path={route.path} component={route.component} key={key} />;
            } else {
              route.hasPermission = false;
              return <Route path="/login" component={Login} />;
            }
          })}
          <Route exact path="/">
            <Redirect to="/home" />
          </Route>
          {!auth.loggedIn && <Redirect from="/" to="/login" />}
        </Layout>
      </Switch>
    </>
  );
}

export default connector(Main);
